/**
 * Adresa de colectare din formularul de comanda, cand bifa «corespunde cu adresa scolii» e pusa.
 *
 * De ce exista (sesizare 2026-10-08): adresa scolii ajungea in formular DOAR printr-un efect legat
 * de bifa. Orice `form.reset(...)` — la incarcarea valorilor implicite, la «Resetare», dupa o
 * trimitere reusita — golea adresa cu bifa ramasa pusa, iar efectul nu mai rula, fiindca bifa nu se
 * schimbase. Campurile sunt dezactivate cat timp bifa e pusa, deci profesorul ramanea cu «Selectați
 * județul» pe un camp pe care nu-l putea atinge. Acum adresa scolii face parte din valorile de
 * `reset`, nu doar din efect.
 */

type CampAdresa =
  | 'judet' | 'oras' | 'comuna' | 'sat' | 'strada' | 'numar'
  | 'codPostal' | 'bloc' | 'scara' | 'etaj' | 'apartament';

const CAMPURI: readonly CampAdresa[] = [
  'judet', 'oras', 'comuna', 'sat', 'strada', 'numar',
  'codPostal', 'bloc', 'scara', 'etaj', 'apartament',
];

/** Ce vine din backend: orice camp poate lipsi sau poate fi `null` (tipurile generate mint). */
export type AdresaDinBackend = { id?: string | null } & Partial<Record<CampAdresa, string | null>>;

export type AdresaDeFormular = { id?: string } & Record<CampAdresa, string>;

/** `null`/lipsa -> `''` pe toate campurile: `addressSchema` respinge `null`. */
export function adresaPentruFormular(adresa: AdresaDinBackend | null | undefined): AdresaDeFormular {
  const rezultat = { id: adresa?.id ?? undefined } as AdresaDeFormular;
  for (const camp of CAMPURI) rezultat[camp] = adresa?.[camp] ?? '';
  return rezultat;
}

/**
 * Adresa cu care porneste formularul. Bifa porneste pusa, deci adresa scolii are prioritate; fara
 * ea (datele scolii inca nu au sosit) ramane ce propune backendul.
 */
export function adresaInitialaDeColectare(
  adresaScolii: AdresaDinBackend | null | undefined,
  adresaImplicita: AdresaDinBackend | null | undefined,
): AdresaDeFormular {
  return adresaPentruFormular(adresaScolii ?? adresaImplicita);
}

/**
 * Judetul si orasul sunt singurele campuri obligatorii din `addressSchema`. O scoala fara ele nu
 * poate trimite comanda cu bifa pusa, iar campurile dezactivate nu-i lasa nicio iesire — de aceea
 * formularul ii spune ce are de facut.
 */
export function adresaScoliiEIncompleta(adresaScolii: AdresaDinBackend | null | undefined): boolean {
  return !adresaScolii?.judet?.trim() || !adresaScolii?.oras?.trim();
}

export const MESAJ_ADRESA_SCOLII_INCOMPLETA =
  'Adresa școlii e incompletă (lipsește județul sau orașul). Completați-o în Datele școlii sau debifați și scrieți adresa de colectare.';
